import useClassNames from '@medflex/hooks/useClassNames';
import * as PropTypes from 'prop-types';
import * as React from 'react';

const LogoIcon = ({ className, ...props }) => {
  const cn = useClassNames(() => ['select-none', 'h-12', className], [className]);
  return (
    <svg
      className={cn}
      data-component="Logo"
      height="100%"
      viewBox="0 0 35 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.3313 0C10.5307 0.00102532 6.88609 1.51728 4.19867 4.21541C1.51125 6.91355 0.00102125 10.5727 0 14.3885L0 37L8.19042 28.7808H14.3313C18.1332 28.7808 21.7794 27.2645 24.4678 24.5654C27.1562 21.8663 28.6665 18.2055 28.6665 14.3885V0H14.3313Z"
        fill="#0052A1"
      />
      <path
        opacity="0.7"
        d="M24.7946 8.33154C27.4993 8.33154 30.0933 9.40943 32.0068 11.3284C33.9203 13.2474 34.9969 15.8505 34.9999 18.5659V34.6794L29.1711 28.8235H24.7946C23.4535 28.8235 22.1255 28.5581 20.8866 28.0425C19.6477 27.5268 18.5221 26.7711 17.5743 25.8184C16.6265 24.8658 15.8751 23.7349 15.3629 22.4904C14.8507 21.246 14.5878 19.9124 14.5894 18.5659V8.33154H24.7946Z"
        fill="#469DF1"
      />
    </svg>
  );
};

LogoIcon.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};

export default LogoIcon;
